/**
 * 私人客户的延期审批必须携带列表中那次申请的上下文。
 * 客户移交、跨日或重新申请后，旧页面不能意外处理另一份申请；普通客户沿用原有调用方式。
 */
export function crmDeferRequestContext(request) {
  if (!request?.requestId) return {};
  return {
    requestId: request.requestId,
    requestDate: request.requestDate,
    expectedOwnershipVersion: request.ownershipVersion,
  };
}
